import { HttpAgent } from '@dfinity/agent'
import { Principal } from '@dfinity/principal'
import { AccountIdentifier } from '@dfinity/ledger-icp'
import LedgerScannerClient, { type NFTBalanceResponse, type NFTToken } from './LedgerScannerClient'
import getAgent from '../utils/getAgent'

import { Chain, ICNFT, type NFTCollection } from '../interfaces/common'

class DabClient {
  public agent: HttpAgent

  constructor() {
    this.agent = getAgent()
  }

  mapNFT(nft: NFTToken, collection: string): ICNFT {
    const { id, url, index, standard } = nft

    return {
      id,
      index,
      url,
      collection,
      standard: standard as ICNFT['standard'],
    }
  }

  mapNFTCollection(dabCollection: NFTBalanceResponse): NFTCollection {
    const { name, icon, tokens, description, canisterId } = dabCollection

    return {
      canisterId,
      name,
      description,
      icon,
      nfts: tokens.map((token) => this.mapNFT(token, canisterId)),
      chain: Chain.ICP,
    }
  }

  async getUserNfts(principalId: string): Promise<NFTCollection[]> {
    const remoteNftFetch = await LedgerScannerClient.fetchNFTs(
      principalId,
      AccountIdentifier.fromPrincipal({
        principal: Principal.from(principalId),
      }).toHex()
    )

    return remoteNftFetch.map(this.mapNFTCollection.bind(this))
  }
}

export default DabClient
